<template>
    <Tooltip
        v-if="remainingDaysWithoutAd"
        :content="$tr('noAdBadge.tooltip', remainingDaysWithoutAd)"
        position="bottom"
    >
        <button
            :class="$style.button"
            data-interface-target="no-ad-badge"
            @click.prevent="adDisabledStore.openDisabledAdModal()"
        >
            <Typography
                type="caption"
                size="xs"
                accent
                :responsive="false"
                :class="$style.no_ad_label"
            >
                {{ $tr('noAdBadge.label') }}
            </Typography>
            <Typography
                type="label"
                size="m"
                accent
                :responsive="false"
                :class="$style.remaining_days"
            >
                {{ $tr('noAdBadge.days', remainingDaysWithoutAd) }}
            </Typography>
        </button>
    </Tooltip>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import Tooltip from '@/components_new/Tooltip.vue'
import Typography from '@/components_new/Typography.vue'
import { useAdDisabledStore } from '@/store/ad-disabled-store'

const adDisabledStore = useAdDisabledStore()
const { remainingDaysWithoutAd } = storeToRefs(adDisabledStore)
</script>

<style module>
.button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 4px 16px;
    background: var(--electric-lime);
    border-radius: 1000px;
    cursor: pointer;
}

.no_ad_label,
.remaining_days {
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1;
}

.no_ad_label {
    color: var(--carbon-400);
    opacity: 0.6;
}

.remaining_days {
    color: var(--black);
}
</style>
